import { render, staticRenderFns } from "./VetSubsidiaries.vue?vue&type=template&id=0328836c&scoped=true"
import script from "./VetSubsidiaries.vue?vue&type=script&lang=js"
export * from "./VetSubsidiaries.vue?vue&type=script&lang=js"
import style0 from "./VetSubsidiaries.vue?vue&type=style&index=0&id=0328836c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328836c",
  null
  
)

export default component.exports